<template>
  <div class="page main-section main-section--white">
    <div class="container">
      <div class="row">
        <div class="col-xl-8 push-xl-2">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page'
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Page.vue